import logger from "@/services/logger.js";

export const namespaced = true;

export const state = {
  details: {},
  trial: 0,
  voidtrial: 0,
  loggedIn: false,
  entryType: "platform",
  error: false,
  errmsg: "",
  emailexisting: "",
  emailcon: "",
  signedup: "",
  voucher: "",
  upgrade_init: false,
  payverifying: false,
  forgotting: false,
  environ: "",
  origin: "",
  site_origin: "",
  api_origin: "",
  apiv2_origin: "",
  orgsnameexisting: "",
  orgnameexisting: "",
  hasTrialsLeft: false,
  freePeriod: false,
  profileupdate: false,
  upgrading: false,
  org_details: {},
  lastVisitedRoute: ""
};

export const mutations = {
  SET_ORIGIN(state) {
    state.environ = process.env.NODE_ENV;

    // let locationorigin = window.location.origin;
    // let regexpatt = /\W?\d*$/;
    // locationorigin.replace(regexpatt, "");

    if (process.env.NODE_ENV == "development") {
      state.site_origin = process.env.VUE_APP_LOCAL_SITE_ORIGIN;
      state.api_origin = process.env.VUE_APP_LOCAL_API_ORIGIN;
      state.apiv2_origin = process.env.VUE_APP_LOCAL_API_V2_ORIGIN;
    } else {
      state.site_origin = process.env.VUE_APP_LIVE_SITE_ORIGIN;
      state.api_origin = process.env.VUE_APP_LIVE_API_ORIGIN;
      state.apiv2_origin = process.env.VUE_APP_LIVE_API_V2_ORIGIN;
    }
  },
  SET_DETAILS(state, details) {
    state.details = details;

    state.environ = process.env.NODE_ENV;

    // let locationorigin = window.location.origin;
    // let regexpatt = /\W?\d*$/;
    // locationorigin.replace(regexpatt, "");

    if (process.env.NODE_ENV == "development") {
      state.origin = process.env.VUE_APP_LOCAL_ORIGIN;
    } else {
      state.origin = process.env.VUE_APP_LIVE_ORIGIN;
    }
  },
  SET_TRIALS(state, trials) {
    state.trial = trials;
  },
  SET_LAST_ROUTE(state, route) {
    state.lastVisitedRoute = route;
  },
  LOGGED_IN(state) {
    state.loggedIn = true;
  },
  LOG_ERROR(state) {
    state.error = true;
  },
  LOG_ERR_MSG(state, msg) {
    state.errmsg = msg;
  },
  SET_ERR(state) {
    state.error = false;
  },
  EMAIL_EXISTS(state, dta) {
    state.emailexisting = dta;
  },
  USER_SIGNED_UP(state, dta) {
    state.signedup = dta;
  },
  EMAIL_CONFIRMED(state) {
    state.emailcon = true;
  },
  SET_VOUCHER(state, dta) {
    state.voucher = dta;
  },
  UPGRADE_INITIALIZED(state) {
    state.upgrade_init = true;
  },
  PAY_VERIFYING(state) {
    state.payverifying = true;
  },
  ORGSNAME_EXISTS(state, dta) {
    state.orgsnameexisting = dta;
  },
  ORGNAME_EXISTS(state, dta) {
    state.orgnameexisting = dta;
  },
  UPDATE_TRIAL(state, trialsLeft) {
    state.hasTrialsLeft = trialsLeft;
    state.voidtrial = 0;
  },
  CHANGE_FREE_SEASON(state, value) {
    state.freePeriod = value;
  },
  SET_ENTRY_TYPE(state, value) {
    state.entryType = value;
  },
  SET_PROFILE_UPDATED(state) {
    state.profileupdate = true;
  },
  UPGRADE_TERMS(state) {
    state.upgrading = true;
  },
  SET_ORGANIZATION_DETAILS(state, details) {
    state.org_details = details;
  },
  SET_PLAN(state, value) {
    state.details.plan = value;
  },
  DESTROY_ALL(state) {
    (state.details = {}),
      (state.trial = 0),
      (state.loggedIn = false),
      (state.error = false),
      (state.errmsg = "");
  }
};

export const actions = {
  destroyAll({ commit }) {
    commit("DESTROY_ALL");
  },
  setPlan({ commit }, value) {
    commit("SET_PLAN", value);
  },
  logOut({ commit }) {
    commit("DESTROY_ALL");

    document.cookie = `remember=0`;
    document.cookie = `qid=***`;
  },

  chkemail({ commit }, email) {
    return logger
      .checkemail(email)
      .then(response => {
        commit("EMAIL_EXISTS", response.data);
        return response.data;
      })
      .catch(error => {
        return error;
      });
  },

  signUp({ commit }, details) {
    return logger
      .signUserup(details)
      .then(response => {
        commit("USER_SIGNED_UP", response.data);

        return response.data;
      })
      .catch(error => {
        return error;
      });
  },

  confirmemail({ commit }, cid) {
    return logger
      .emailConfirm(cid)
      .then(response => {
        commit("EMAIL_CONFIRMED");

        return response.data;
      })
      .catch(error => {
        return error;
      });
  },
  resendVerifyMail({ commit }, payload) {
    return logger
      .resendMail(payload.email, payload.origin)
      .then(response => {
        commit("EMAIL_CONFIRMED");

        return response.data;
      })
      .catch(error => {
        return error.data;
      });
  },
  saveLastRoute({ commit }, payload) {
    commit("SET_LAST_ROUTE", payload);
  },

  saveOrgProfile({ commit }, profileObj) {
    return logger.saveOrgProfile(profileObj).then(() => {
      commit("SET_PROFILE_UPDATED");
    });
  },

  getPremiumPlans({ commit }) {
    return logger.getPremiumPlans().then(response => {
      commit("SET_PROFILE_UPDATED");
      return response.data;
    });
  },

  sendLogin({ commit, dispatch }, details) {
    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
    return logger
      .loginUser(details)
      .then(response => {
        console.log(response)
        if (response.data.loggedin) {
          let remember = getCookie("remember");

          if (remember != 1) {
            //let now = new Date();
            //now.setFullYear(now.getFullYear() + 5)
            document.cookie = `remember=1;`;
            document.cookie = `qid=${response.data.details.trackid};`;
          }

          if (
            response.data.details.free_season_details.free_season == "started"
          ) {
            commit("CHANGE_FREE_SEASON", true);
          } else if (
            response.data.details.free_season_details.free_season == "ended"
          ) {
            commit("CHANGE_FREE_SEASON", false);
          } else {
            commit("CHANGE_FREE_SEASON", false);
          }

          commit("LOGGED_IN");
          dispatch("loggedOut", null, {
            root: true
          });
          commit("SET_DETAILS", response.data.details);

          commit("SET_TRIALS", response.data?.details?.trial);

          dispatch("trialsLeft", null);
          dispatch("setOrigin", null);
        } else {
          commit("LOG_ERROR");

          if (response.data.message == "empty") {
            commit(
              "LOG_ERR_MSG",
              "Password and Email fields cannot be left empty"
            );
          } else if (response.data.message == "incorrect") {
            commit(
              "LOG_ERR_MSG",
              "Email and Password Incorrect. Not yet registered? Click on <b-link :to='{name : 'signup' }'>Sign Up</b-link> or <b-link :to='{ name : 'forgot'}'>Forgot Password</b-link>"
            );
          } else if (response.data.message == "unconfirmed") {
            commit(
              "LOG_ERR_MSG",
              `You have not confirmed Your email. Please Check your mailbox and click on the link sent to ${details.email}`
            );
          } else if (response.data.message == "deleted") {
            commit(
              "LOG_ERR_MSG",
              `This account no longer exists. Contact the admin for renewal procedures`
            );
          } else if (response.data.reason == "outdated") {
            commit(
              "LOG_ERR_MSG",
              `This app version is no longer supported. Please update your app to continue using Quicktest`
            );
          } else {
            commit("LOG_ERR_MSG", response?.data?.message);
          }
        }

        if (response.data.ongoing) {
          dispatch("exam/setcontinuefromlogin", response.data.ongoingconfig, {
            root: true
          });
        }

        return response.data;
      })
      .catch((err) => {
        console.log(err)

        return err;
      });
  },

  sendLoginOrgCandidate({ commit, dispatch }, details) {
    return logger.loginOrgCandidate(details).then(response => {
      if (response.data.loggedin) {
        commit("LOGGED_IN");
        dispatch("loggedOut", null, {
          root: true
        });
        dispatch("trialsLeft", null);
        dispatch("setOrigin", null);
        commit("SET_DETAILS", response.data.details);
      }

      return response;
    });
  },
  setErr({ commit }) {
    commit("SET_ERR");
  },
  trialsLeft({ commit, state }) {
    if (state.freePeriod) {
      commit("UPDATE_TRIAL", true);
    } else if (state.details?.trial > 0) {
      commit("UPDATE_TRIAL", true);
    } else if (state.details?.trial <= 0 && state.details?.plan != "Premium") {
      commit("UPDATE_TRIAL", false);
    } else {
      commit("UPDATE_TRIAL", false);
    }
  },

  getVoucher({ commit }) {
    return logger.getVcode().then(response => {
      commit("SET_VOUCHER", response.data);

      return response.data;
    });
  },

  async userUpgrade({ commit }, upgradeobj) {
    return await logger.upgrader(upgradeobj).then(response => {
      commit("UPGRADE_TERMS");

      return response.data;
    });
  },
  verifyPay({ commit }, refObj) {
    return logger
      .payVerify(refObj)
      .then(response => {
        commit("PAY_VERIFYING");

        return response.data;
      })
      .catch(error => {
        return error;
      });
  },
  forgotP({ commit }, emailobj) {
    return logger
      .pwordForgot(emailobj)
      .then(response => {
        commit("PWORD_FORGOT");

        return response.data;
      })
      .catch(error => {
        return error;
      });
  },
  resetPword({ commit }, pwordobj) {
    return logger
      .pwordReset(pwordobj)
      .then(response => {
        commit("PWORD_RESET");

        return response.data;
      })
      .catch(error => {
        return error;
      });
  },
  updateDetails({ commit, state }) {
    return logger.getDetails(state.details.trackid).then(response => {
      commit("SET_DETAILS", response.data.details);
    });
  },
  chkorgsname({ commit }, orgsname) {
    return logger
      .checkorgsname(orgsname)
      .then(response => {
        commit("ORGSNAME_EXISTS", response.data);
        //console.log(response)
        return response.data;
      })
      .catch(error => {
        return error;
      });
  },
  chkorgname({ commit }, orgname) {
    return logger
      .checkorgname(orgname)
      .then(response => {
        commit("ORGNAME_EXISTS", response.data);
        //console.log(response)
        return response.data;
      })
      .catch(error => {
        return error;
      });
  },
  setOrigin({ commit }) {
    commit("SET_ORIGIN");
  },
  setEntryType({ commit }, type) {
    commit("SET_ENTRY_TYPE", type);
  },
  deleteUserAccount({ commit }) {
    return logger.deleteAccountUser(state.details.trackid).then(() => {
      commit("SET_DETAILS");
    });
  },
  fetchOrgDetails({ commit }, orgShortname) {
    return logger.getOrgDetails(orgShortname).then(response => {
      commit("SET_ORGANIZATION_DETAILS", response.data.data);
      return response;
    });
  }
};

export const getters = {};
